import VerticalDashIcon from './icons/vertical-dash';
import './P2HeaderDropdown.scss';
import { Fragment } from 'react';

export default function P2HeaderDropdown({ item, variant, ...props }) {
  return (
    <div className={"polymer-header-dropdown " + (
      variant === 'nav'
      ? 'polymer-header-border-yellow'
      : variant === 'info'
      ? 'polymer-header-border-red'
      : ''
    )} {...props}>
      <div className="polymer-header-dropdown-inner">
        {item.icon && <div className="polymer-header-dropdown-icon">
          {item.icon}
        </div>}
        {item.sections.map((section, sectionIndex) => (
          <Fragment key={sectionIndex}>
            <div className="polymer-header-dropdown-section">
              <div className="polymer-header-dropdown-section-header">{section.header}</div>
              {section.links.map((link, linkIndex) => (
                <a href={link.url} key={linkIndex} className="polymer-header-dropdown-section-link">{link.text}</a>
              ))}
            </div>
            {sectionIndex !== item.sections.length - 1 && <div className="polymer-header-dropdown-divider">
              <VerticalDashIcon />
            </div>}
          </Fragment>
        ))}
      </div>
    </div>
  )
}